/**
 * Moduł sticky boxa na karcie produktu,
 * ustawienie pozycji boxa
 * @type module
 */
app.service('productForSale',function($global, html, cookie, broker, price) {
	var enabled=cookie.isEmpty('sticky-off');
	var $self, $productSales, $container, $sticky;
	var maxScroll=0;
	function setElements() {
		$self=$('#product-for-sale');
		$productSales = $('#product-top .product-sales');
		$container = $('#product-tabs');
		$sticky=$('#top');
	}

	function setEvents() {
		var ticking=false;
		$(window).on('promotion-bar-close',function(){
			positionElement();
		});
		$(window).on('scroll resize', function(event, data){
			if (!ticking) {
				requestAnimationFrame(function(){
					positionElement();
					ticking = false;
				});
			}
			ticking = true;
		});
		broker.on('PRODUCT_PRICE_VARIANT_CHANGE', handleProductPriceChange);
	}

	function handleProductPriceChange(e, props) {
		if(props.productPrice) {
			const numberPrice = props.productPrice*1;
			const formattedProductPrice = price.format(props.productPrice);
			$('.product-prices-box .price-normal', $self).text(formattedProductPrice);
			$('.js-add-to-cart', $self).attr('data-custom-price', numberPrice);
		}
	}

	function positionElement() {
		var scroll=$(window).scrollTop();
		if($productSales.offset().top+$productSales.height()<scroll+$sticky.height()){
			html.add('product-for-sales-show');
			if(parseInt($container.offset().top+$container.height())<parseInt($self.height()+scroll)){
				maxScroll=scroll;
				$self.addClass('position-bottom').removeClass('position-top');
			}else{
				if((scroll<maxScroll || maxScroll===0)){
					$self.removeClass('position-bottom').addClass('position-top');
					$self.css('top',$sticky.height());
				}
			}
		}else{
			html.remove('product-for-sales-show');
		}
	}

	function init() {
		if(enabled){
			setElements();
			if($self.length && $productSales.length){
				setEvents();
				positionElement();
			}
		}
	}

	return {
		init: init
	};
});
